/*
 *  Copyright (c) Qwoach LLC 2022. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 17/1/2022
 */

import TimelineEventItem from "@shared/Timeline/TimelineEventItem";
import {Type} from "class-transformer";
import {ClearanceLevelEnum} from "@shared/Profile/ClearanceLevelEnum.js";
import FilterableItem from "@shared/Filterable/FilterableItem.js";

export default class TimelineItem extends FilterableItem {

	@Type(() => TimelineEventItem)
	timelineEvents: TimelineEventItem[] = []
	clientId: string = null
	clearanceLevel: ClearanceLevelEnum = ClearanceLevelEnum.PHI

	constructor(clientId: string) {
		super();
		this.clientId = clientId;
	}

	addEvent(timelineEventItem){
		this.timelineEvents.push(timelineEventItem)
	}

	updateEventById(timelineEventItem){
		let index = this.findEventIndexById(timelineEventItem.id)
		if(index >= 0){
			this.timelineEvents.splice(index, 1, timelineEventItem)
		}
	}

	removeEvent(timelineEventItem){
		let index = this.findEventIndexById(timelineEventItem.id)
		if(index >= 0){
			this.timelineEvents.splice(index, 1)
		}
	}

	findEventById(timelineEventItemId){
		let index = this.findEventIndexById(timelineEventItemId)
		if(index >= 0){
			return this.timelineEvents[index]
		}
		return null
	}

	findEventIndexById(timelineEventItemId){
		return this.timelineEvents.findIndex(event => event.id === timelineEventItemId)
	}
}
